import { ISettingsEntity } from "./settings.entity";
import { CrewPermissionsService } from "../../core/crew-permissions.service";

export abstract class ListBase<TEntity extends ISettingsEntity> {

    isPermissionWriteOrAdmin: boolean;

    constructor(
        public entities: TEntity[],
        crewPermissionsService: CrewPermissionsService) {

        crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);
    }

    public abstract newEntityState: string;
    
    public abstract editEntityState: string;

    public abstract entityName: string;

    public abstract entityNames: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/shared/list.base.ts